module.exports = __webpack_public_path__ + "media/images/pic/lectors/iga-figiel-a6efbf718e36dcb0c54d54213d5887e0.jpeg";